import { render, staticRenderFns } from "./Treaty.vue?vue&type=template&id=201c178e&"
import script from "./Treaty.vue?vue&type=script&lang=js&"
export * from "./Treaty.vue?vue&type=script&lang=js&"
import style0 from "./Treaty.vue?vue&type=style&index=0&id=201c178e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports